<template>
  <o-form-wrapper
    :form-state="formState"
    :schema="schema"
    :server-errors="_se"
    :v="$v.item"
    v-model="item"
  >
    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="client"
    >
      <o-select
        :form-state="formState"
        :items="optionOcomClientItems"
        :loading="optionOcomClientWorking"
        :server-errors="_se"
        :validators="$v.item"
        add-title="Create New"
        allow-add
        name="client"
        sort-field="name"
        store-name="OcomClient"
        text-field="name"
        v-bind="schema.fields.client"
        v-model="item.client"
        value-field="id"
      >
        <template slot="form" slot-scope="{ item, formState, serverErrors }">
          <ocom-client-form
            :form-state="formState"
            :item="item"
            :server-errors="serverErrors"
            in-modal
          ></ocom-client-form>
        </template>
      </o-select>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="project_name"
    >
      <o-text-field
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="project_name"
        v-bind="schema.fields.project_name"
        v-model="item.project_name"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="contact_name"
    >
      <o-text-field
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="contact_name"
        v-bind="schema.fields.contact_name"
        v-model="item.contact_name"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="won_date"
    >
      <o-date-time
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        hide-time
        name="won_date"
        v-bind="schema.fields.won_date"
        v-model="item.won_date"
      ></o-date-time>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="lost_date"
    >
      <o-date-time
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        hide-time
        name="lost_date"
        v-bind="schema.fields.lost_date"
        v-model="item.lost_date"
      ></o-date-time>
    </o-widget-wrapper>
    <b-tabs>
      <b-tab title="Modules">
        <o-widget-wrapper
          :form-state="formState"
          :schema="schema"
          :server-errors="_se"
          :validators="$v.item"
          name="modules"
        >
          <quote-line-form-table
            :form-state="formState"
            :label="schema.fields.modules.label"
            :level="level + 1"
            :server-errors="_se.modules"
            :validators="$v.item.modules"
            v-model="item.modules"
          >
          </quote-line-form-table>
          <!-- UNCOMMENT TO USE Cards
              <quote-line-form-cards v-model="item.modules"
                  :validators="$v.item.modules"
                  :form-state="formState"
                  :label="schema.fields.modules.label"
                  :level="level+1"
                  :server-errors="_se.modules]">
              </quote-line-form-cards>
              -->
        </o-widget-wrapper>

        <table class="table table-bordered table-full">
          <tr>
            <td>Total</td>
            <td>{{ to_decimals(totalbest_case, 2) }}</td>
            <td>{{ to_decimals(totalmost_likely_case, 2) }}</td>
            <td>{{ to_decimals(totalworst_case, 2) }}</td>
            <td>
              {{ to_decimals(totalExpectedCase, 2) }}d =
              {{ to_decimals(totalExpectedCaseWeeks, 2) }}w
            </td>
          </tr>
        </table>
      </b-tab>
      <b-tab title="Variables">
        <o-widget-wrapper
          :form-state="formState"
          :schema="schema"
          :server-errors="_se"
          :validators="$v.item"
          name="non_project_hourly_rate"
        >
          <o-text-field
            :form-state="formState"
            :server-errors="_se"
            :validators="$v.item"
            name="non_project_hourly_rate"
            v-bind="schema.fields.non_project_hourly_rate"
            v-model="item.non_project_hourly_rate"
          ></o-text-field>
        </o-widget-wrapper>

        <o-widget-wrapper
          :form-state="formState"
          :schema="schema"
          :server-errors="_se"
          :validators="$v.item"
          name="project_hourly_rate"
        >
          <o-text-field
            :form-state="formState"
            :server-errors="_se"
            :validators="$v.item"
            name="project_hourly_rate"
            v-bind="schema.fields.project_hourly_rate"
            v-model="item.project_hourly_rate"
          ></o-text-field>
        </o-widget-wrapper>

        <o-widget-wrapper
          :form-state="formState"
          :schema="schema"
          :server-errors="_se"
          :validators="$v.item"
          name="project_weekly_rate"
        >
          <o-text-field
            :form-state="formState"
            :server-errors="_se"
            :validators="$v.item"
            name="project_weekly_rate"
            v-bind="schema.fields.project_weekly_rate"
            v-model="item.project_weekly_rate"
          ></o-text-field>
        </o-widget-wrapper>

        <o-widget-wrapper
          :form-state="formState"
          :schema="schema"
          :server-errors="_se"
          :validators="$v.item"
          name="markup_for_fast_tracked"
        >
          <o-text-field
            :form-state="formState"
            :server-errors="_se"
            :validators="$v.item"
            name="markup_for_fast_tracked"
            v-bind="schema.fields.markup_for_fast_tracked"
            v-model="item.markup_for_fast_tracked"
          ></o-text-field>
        </o-widget-wrapper>

        <o-widget-wrapper
          :form-state="formState"
          :schema="schema"
          :server-errors="_se"
          :validators="$v.item"
          name="include_hosting"
        >
          <o-checkbox
            :form-state="formState"
            :server-errors="_se"
            :validators="$v.item"
            name="include_hosting"
            v-bind="schema.fields.include_hosting"
            v-model="item.include_hosting"
          ></o-checkbox>
        </o-widget-wrapper>

        <o-widget-wrapper
          :form-state="formState"
          :schema="schema"
          :server-errors="_se"
          :validators="$v.item"
          name="monthly_hosting"
          v-if="item.include_hosting"
        >
          <o-text-field
            :form-state="formState"
            :server-errors="_se"
            :validators="$v.item"
            name="monthly_hosting"
            v-bind="schema.fields.monthly_hosting"
            v-model="item.monthly_hosting"
          ></o-text-field>
        </o-widget-wrapper>

        <o-widget-wrapper
          :form-state="formState"
          :schema="schema"
          :server-errors="_se"
          :validators="$v.item"
          name="warranty_period"
        >
          <o-text-field
            :form-state="formState"
            :server-errors="_se"
            :validators="$v.item"
            name="warranty_period"
            v-bind="schema.fields.warranty_period"
            v-model="item.warranty_period"
          ></o-text-field>
        </o-widget-wrapper>

        <o-widget-wrapper
          :form-state="formState"
          :schema="schema"
          :server-errors="_se"
          :validators="$v.item"
          name="software_as_a_service"
        >
          <o-checkbox
            :form-state="formState"
            :server-errors="_se"
            :validators="$v.item"
            name="software_as_a_service"
            v-bind="schema.fields.software_as_a_service"
            v-model="item.software_as_a_service"
          ></o-checkbox>
        </o-widget-wrapper>

        <o-widget-wrapper
          :form-state="formState"
          :schema="schema"
          :server-errors="_se"
          :validators="$v.item"
          name="saas_markup"
          v-if="item.software_as_a_service"
        >
          <o-text-field
            :form-state="formState"
            :server-errors="_se"
            :validators="$v.item"
            name="saas_markup"
            v-bind="schema.fields.saas_markup"
            v-model="item.saas_markup"
          ></o-text-field>
        </o-widget-wrapper>
      </b-tab>

      <b-tab title="Results">
        <h1>Results</h1>

        <table
          class="table table-bordered"
          style="width: 600px; font-size: 10pt; font-style: arial"
        >
          <thead>
            <th
              class="span3 resultCenter"
              style="
                padding: 0px;
                background-color: #fabf8f;
                text-align: center;
              "
            >
              Item
            </th>
            <th
              class="span2 resultCenter"
              style="
                padding: 0px;
                background-color: #fabf8f;
                text-align: center;
              "
            >
              Individual Modules
            </th>
            <th
              class="span2 resultCenter"
              style="
                padding: 0px;
                background-color: #fabf8f;
                text-align: center;
              "
            >
              Project Package
            </th>
            <th
              class="span2 resultCenter"
              style="
                padding: 0px;
                background-color: #fabf8f;
                text-align: center;
              "
            >
              Priority Fast Tracked Stream
            </th>
            <th
              class="span2 resultCenter"
              style="
                padding: 0px;
                background-color: #fabf8f;
                text-align: center;
              "
              v-if="item.software_as_a_service"
            >
              SAS 12 Months
            </th>
            <th
              class="span2 resultCenter"
              style="
                padding: 0px;
                background-color: #fabf8f;
                text-align: center;
              "
              v-if="item.software_as_a_service"
            >
              SAS 24 Months
            </th>
          </thead>
          <tbody>
            <tr v-for="module in item.modules">
              <td
                class="span3"
                style="
                  padding: 0px;
                  text-size: 10pt;
                  text-align: left;
                  font-weight: bold;
                "
              >
                {{ module.description }}
              </td>
              <td style="padding: 0px; text-size: 10pt; text-align: right">
                {{
                  to_decimals(
                    expected_case(module) * 8 * item.non_project_hourly_rate,
                    2
                  )
                }}
              </td>
              <td style="padding: 0px; text-align: center">&#10004;</td>
              <td style="padding: 0px; text-align: center">&#10004;</td>
              <td
                style="padding: 0px; text-align: center"
                v-if="item.software_as_a_service"
              >
                &#10004;
              </td>
              <td
                style="padding: 0px; text-align: center"
                v-if="item.software_as_a_service"
              >
                &#10004;
              </td>
            </tr>

            <tr>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td v-if="item.software_as_a_service">&nbsp;</td>
              <td v-if="item.software_as_a_service">&nbsp;</td>
            </tr>

            <tr style="background-color: #fabf8f">
              <td
                class="span3"
                style="
                  padding: 0px;
                  text-size: 10pt;
                  text-align: left;
                  font-weight: bold;
                "
              >
                Extra Functionality Not Specified
              </td>
              <td style="padding: 0px; text-size: 10pt; text-align: right">
                {{ to_decimals(item.non_project_hourly_rate, 2) }}/hr
              </td>
              <td style="padding: 0px; text-size: 10pt; text-align: right">
                {{ to_decimals(item.project_hourly_rate, 2) }}/hr
              </td>
              <td style="padding: 0px; text-size: 10pt; text-align: right">
                {{ to_decimals(item.project_hourly_rate, 2) }}/hr
              </td>
              <td
                style="padding: 0px; text-size: 10pt; text-align: right"
                v-if="item.software_as_a_service"
              >
                {{ to_decimals(item.project_hourly_rate, 2) }}/hr
              </td>
              <td
                style="padding: 0px; text-size: 10pt; text-align: right"
                v-if="item.software_as_a_service"
              >
                {{ to_decimals(item.project_hourly_rate, 2) }}/hr
              </td>
            </tr>

            <tr>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td v-if="item.software_as_a_service">&nbsp;</td>
              <td v-if="item.software_as_a_service">&nbsp;</td>
            </tr>

            <tr style="background-color: #fabf8f">
              <td
                class="span3"
                style="
                  padding: 0px;
                  text-size: 10pt;
                  text-align: left;
                  font-weight: bold;
                "
              >
                Delivery Time Frame (Estimate)
              </td>
              <td>-</td>
              <td style="padding: 0px; text-size: 10pt; text-align: right">
                {{ to_decimals(totalExpectedCaseWeeks * 1.4, 0) }} -
                {{ to_decimals(totalExpectedCaseWeeks * 1.4 * 1.2, 0) }} Weeks
              </td>
              <td style="padding: 0px; text-size: 10pt; text-align: right">
                {{ to_decimals(totalExpectedCaseWeeks, 0) }} -
                {{ to_decimals(totalExpectedCaseWeeks * 1.4, 0) }} Weeks
              </td>
              <td
                style="padding: 0px; text-size: 10pt; text-align: right"
                v-if="item.software_as_a_service"
              >
                {{ to_decimals(totalExpectedCaseWeeks * 1.4, 0) }} -
                {{ to_decimals(totalExpectedCaseWeeks * 1.4 * 1.1, 0) }} Weeks
              </td>
              <td
                style="padding: 0px; text-size: 10pt; text-align: right"
                v-if="item.software_as_a_service"
              >
                {{ to_decimals(totalExpectedCaseWeeks * 1.4, 0) }} -
                {{ to_decimals(totalExpectedCaseWeeks * 1.4 * 1.1, 0) }} Weeks
              </td>
            </tr>

            <tr style="background-color: #fabf8f">
              <td
                class="span3"
                style="
                  padding: 0px;
                  text-size: 10pt;
                  text-align: left;
                  font-weight: bold;
                "
              >
                Warranty Period of Free Support
              </td>
              <td style="padding: 0px; text-size: 10pt; text-align: right">
                Not Applicable
              </td>
              <td style="padding: 0px; text-size: 10pt; text-align: right">
                {{ item.warranty_period }} Month(s)
              </td>
              <td style="padding: 0px; text-size: 10pt; text-align: right">
                {{ item.warranty_period }} Month(s)
              </td>
              <td
                style="padding: 0px; text-size: 10pt; text-align: right"
                v-if="item.software_as_a_service"
              >
                {{ item.warranty_period }} Month(s)
              </td>
              <td
                style="padding: 0px; text-size: 10pt; text-align: right"
                v-if="item.software_as_a_service"
              >
                {{ item.warranty_period }} Month(s)
              </td>
            </tr>

            <tr>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td v-if="item.software_as_a_service">&nbsp;</td>
              <td v-if="item.software_as_a_service">&nbsp;</td>
            </tr>

            <tr style="background-color: #fabf8f">
              <td
                class="span3"
                style="
                  padding: 0px;
                  text-size: 10pt;
                  text-align: left;
                  font-weight: bold;
                "
              >
                Maintenance Fee
              </td>
              <td style="padding: 0px; text-size: 10pt; text-align: right">
                {{ to_decimals(item.non_project_hourly_rate, 2) }}/hr
              </td>
              <td style="padding: 0px; text-size: 10pt; text-align: right">
                {{ to_decimals(maintenanceFeeProject, 2) }}/month
              </td>
              <td style="padding: 0px; text-size: 10pt; text-align: right">
                {{ to_decimals(maintenanceFeeFastTracked, 2) }}/month
              </td>
              <td
                style="padding: 0px; text-size: 10pt; text-align: right"
                v-if="item.software_as_a_service"
              >
                {{ to_decimals(maintenanceFeeProject, 2) }}/month
              </td>
              <td
                style="padding: 0px; text-size: 10pt; text-align: right"
                v-if="item.software_as_a_service"
              >
                {{ to_decimals(maintenanceFeeProject, 2) }}/month
              </td>
            </tr>

            <tr style="background-color: #fabf8f">
              <td
                class="span3"
                style="
                  padding: 0px;
                  text-size: 10pt;
                  text-align: left;
                  font-weight: bold;
                "
              >
                Contract Period
              </td>
              <td style="padding: 0px; text-size: 10pt; text-align: right"></td>
              <td style="padding: 0px; text-size: 10pt; text-align: right">
                12 Months
              </td>
              <td style="padding: 0px; text-size: 10pt; text-align: right">
                12 Months
              </td>
              <td
                style="padding: 0px; text-size: 10pt; text-align: right"
                v-if="item.software_as_a_service"
              >
                12 Months
              </td>
              <td
                style="padding: 0px; text-size: 10pt; text-align: right"
                v-if="item.software_as_a_service"
              >
                24 Months
              </td>
            </tr>

            <tr style="background-color: #fabf8f">
              <td
                class="span3"
                style="
                  padding: 0px;
                  text-size: 10pt;
                  text-align: left;
                  font-weight: bold;
                "
              >
                Included Remote, Phone and Email Support
              </td>
              <td style="padding: 0px; text-size: 10pt; text-align: right">
                As you go
              </td>
              <td style="padding: 0px; text-size: 10pt; text-align: right">
                {{ to_decimals(maintenanceHours, 0) }} Hour(s)
              </td>
              <td style="padding: 0px; text-size: 10pt; text-align: right">
                {{ to_decimals(maintenanceHours, 0) }} Hour(s)
              </td>
              <td
                style="padding: 0px; text-size: 10pt; text-align: right"
                v-if="item.software_as_a_service"
              >
                {{ to_decimals(maintenanceHours, 0) }} Hour(s)
              </td>
              <td
                style="padding: 0px; text-size: 10pt; text-align: right"
                v-if="item.software_as_a_service"
              >
                {{ to_decimals(maintenanceHours, 0) }} Hour(s)
              </td>
            </tr>

            <tr style="background-color: #fabf8f" v-if="item.include_hosting">
              <td
                class="span3"
                style="
                  padding: 0px;
                  text-size: 10pt;
                  text-align: left;
                  font-weight: bold;
                "
              >
                Hosting (Includes backup and monitoring)
              </td>
              <td style="padding: 0px; text-size: 10pt; text-align: right">
                {{ to_decimals(item.monthly_hosting, 2) }}
              </td>
              <td style="padding: 0px; text-size: 10pt; text-align: right">
                {{ to_decimals(item.monthly_hosting, 2) }}
              </td>
              <td style="padding: 0px; text-size: 10pt; text-align: right">
                {{ to_decimals(item.monthly_hosting, 2) }}
              </td>
              <td
                style="padding: 0px; text-size: 10pt; text-align: right"
                v-if="item.software_as_a_service"
              >
                {{ to_decimals(item.monthly_hosting, 2) }}
              </td>
              <td
                style="padding: 0px; text-size: 10pt; text-align: right"
                v-if="item.software_as_a_service"
              >
                {{ to_decimals(item.monthly_hosting, 2) }}
              </td>
            </tr>

            <tr>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td v-if="item.software_as_a_service">&nbsp;</td>
              <td v-if="item.software_as_a_service">&nbsp;</td>
            </tr>

            <tr
              class="totalRow"
              style="background-color: #fabf8f; font-size: 14pt"
            >
              <td
                class="span3"
                style="
                  padding: 0px;
                  text-size: 10pt;
                  text-align: left;
                  font-weight: bold;
                "
              >
                Total Upfront Cost
              </td>
              <td style="padding: 0px; text-size: 10pt; text-align: right">
                {{ to_decimals(totalUpfrontCostHourly, 2) }}
              </td>
              <td style="padding: 0px; text-size: 10pt; text-align: right">
                {{ to_decimals(totalUpfrontCostProject, 2) }}
              </td>
              <td style="padding: 0px; text-size: 10pt; text-align: right">
                {{ to_decimals(totalUpfrontCostFastTracked, 2) }}
              </td>
              <td
                style="padding: 0px; text-size: 10pt; text-align: right"
                v-if="item.software_as_a_service"
              >
                {{ to_decimals(totalUpfrontCostProject * item.saas_markup, 2) }}
              </td>
              <td
                style="padding: 0px; text-size: 10pt; text-align: right"
                v-if="item.software_as_a_service"
              >
                {{ to_decimals(totalUpfrontCostProject * item.saas_markup, 2) }}
              </td>
            </tr>
            <tr style="background-color: #fabf8f">
              <td
                class="span3"
                style="
                  padding: 0px;
                  text-size: 10pt;
                  text-align: left;
                  font-weight: bold;
                "
              >
                Total Monthly Cost
              </td>
              <td style="padding: 0px; text-size: 10pt; text-align: right">
                {{ to_decimals(monthly_hosting, 2) }}
              </td>
              <td style="padding: 0px; text-size: 10pt; text-align: right">
                {{ to_decimals(monthlyProject, 2) }}
              </td>
              <td style="padding: 0px; text-size: 10pt; text-align: right">
                {{ to_decimals(monthlyFastTracked, 2) }}
              </td>
              <td
                style="padding: 0px; text-size: 10pt; text-align: right"
                v-if="item.software_as_a_service"
              >
                {{
                  to_decimals(
                    (totalUpfrontCostProject * (1 - item.saas_markup)) / 12 +
                      monthlyProject,
                    2
                  )
                }}
              </td>
              <td
                style="padding: 0px; text-size: 10pt; text-align: right"
                v-if="item.software_as_a_service"
              >
                {{
                  to_decimals(
                    (totalUpfrontCostProject * (1 - item.saas_markup)) / 24 +
                      monthlyProject,
                    2
                  )
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </b-tab>

      <b-tab title="Download">
        <o-widget-wrapper
          :form-state="formState"
          :schema="schema"
          :server-errors="_se"
          :validators="$v.item"
          name="company_name"
        >
          <o-text-field
            :form-state="formState"
            :server-errors="_se"
            :validators="$v.item"
            name="company_name"
            v-bind="schema.fields.company_name"
            v-model="item.company_name"
          ></o-text-field>
        </o-widget-wrapper>

        <o-widget-wrapper
          :form-state="formState"
          :schema="schema"
          :server-errors="_se"
          :validators="$v.item"
          name="address_line1"
        >
          <o-text-field
            :form-state="formState"
            :server-errors="_se"
            :validators="$v.item"
            name="address_line1"
            v-bind="schema.fields.address_line1"
            v-model="item.address_line1"
          ></o-text-field>
        </o-widget-wrapper>

        <o-widget-wrapper
          :form-state="formState"
          :schema="schema"
          :server-errors="_se"
          :validators="$v.item"
          name="address_line2"
        >
          <o-text-field
            :form-state="formState"
            :server-errors="_se"
            :validators="$v.item"
            name="address_line2"
            v-bind="schema.fields.address_line2"
            v-model="item.address_line2"
          ></o-text-field>
        </o-widget-wrapper>

        <o-widget-wrapper
          :form-state="formState"
          :schema="schema"
          :server-errors="_se"
          :validators="$v.item"
          name="app_description"
        >
          <o-text-field
            :form-state="formState"
            :server-errors="_se"
            :validators="$v.item"
            name="app_description"
            v-bind="schema.fields.app_description"
            v-model="item.app_description"
          ></o-text-field>
        </o-widget-wrapper>

        <o-widget-wrapper
          :form-state="formState"
          :schema="schema"
          :server-errors="_se"
          :validators="$v.item"
          name="app_helps_with"
        >
          <o-text-field
            :form-state="formState"
            :server-errors="_se"
            :validators="$v.item"
            name="app_helps_with"
            v-bind="schema.fields.app_helps_with"
            v-model="item.app_helps_with"
          ></o-text-field>
        </o-widget-wrapper>

        <o-widget-wrapper
          :form-state="formState"
          :schema="schema"
          :server-errors="_se"
          :validators="$v.item"
          name="app_process_of"
        >
          <o-text-field
            :form-state="formState"
            :server-errors="_se"
            :validators="$v.item"
            name="app_process_of"
            v-bind="schema.fields.app_process_of"
            v-model="item.app_process_of"
          ></o-text-field>
        </o-widget-wrapper>

        <o-widget-wrapper
          :form-state="formState"
          :schema="schema"
          :server-errors="_se"
          :validators="$v.item"
          name="app_effort"
        >
          <o-text-field
            :form-state="formState"
            :server-errors="_se"
            :validators="$v.item"
            name="app_effort"
            v-bind="schema.fields.app_effort"
            v-model="item.app_effort"
          ></o-text-field>
        </o-widget-wrapper>

        <b-btn
          @click="
            downloadDocument('ocom_quote_template.docx', 'intro_letter.docx')
          "
          variant="success"
          >Download Intro Letter
        </b-btn>
        <b-btn
          @click="
            downloadDocument(
              'ocom_terms_and_conditions_template.docx',
              'terms_and_conditions.docx'
            )
          "
          variant="success"
        >
          Download Terms and Conditions
        </b-btn>
      </b-tab>
    </b-tabs>
  </o-form-wrapper>
</template>

<script>
import numeral from "numeral";
import moment from "moment";

import schema from "../../schema/index";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin,
} from "../../../vue-ocom/mixins";
import { validationMixin } from "vuelidate";
import OWidgetWrapper from "../../../vue-ocom/components/forms/OWidgetWrapper";
import OTextField from "../../../vue-ocom/components/forms/fields/OTextField";
import OSelect from "../../../vue-ocom/components/forms/fields/OSelect";
import OCheckbox from "../../../vue-ocom/components/forms/fields/OCheckbox";
import OFormWrapper from "../../../vue-ocom/components/forms/OFormWrapper";
import ODateTime from "../../../vue-ocom/components/forms/fields/ODateTime";

import { default as OcomClientForm } from "../../ocom_client/components/ItemForm";
// import { default as QuoteLineFormCards } from '../../quote_line/components/ItemFormCards';
import { default as QuoteLineFormTable } from "../../quote_line/components/ItemFormTable";

export default {
  mixins: [
    VuelidateMixin,
    validationMixin,
    CreateFormStateMixin("$v"),
    CreateGroupPermissionMixin("OcomQuoteOld"),
    CreateCodeTableFetchMixin(["OcomClient", "CodeQuoteType"]),
  ],
  components: {
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,

    OCheckbox,
    OSelect,
    OTextField,

    OcomClientForm,
    QuoteLineFormTable, //QuoteLineFormCards,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    level: { type: Number, default: 0 },
    inModal: { type: Boolean, default: false },
  },
  data: () => ({
    schemaModel: cleanUpModel(schema.OcomQuoteOld, {}),
  }),
  methods: {
    expected_case: function (module) {
      if (
        !isNaN(module.best_case) &&
        !isNaN(module.most_likely_case) &&
        !isNaN(module.worst_case)
      ) {
        return (
          (parseFloat(module.best_case) +
            3 * parseFloat(module.most_likely_case) +
            2 * parseFloat(module.worst_case)) /
          6
        );
      } else {
        return 0;
      }
    },
    to_decimals(number, decimals) {
      const num = numeral(number);
      decimals = decimals || 0;

      if (decimals == 0) return num.format("0,0");
      if (decimals == 2) return num.format("0,0.00");
    },

    downloadDocument(filename, out_filename) {
      var vm = this;
      var fields = _.clone(this.item);

      _.each(fields.modules, function (module) {
        module.hourly_cost = vm.to_decimals(
          vm.expected_case(module) * 8 * vm.item.non_project_hourly_rate,
          2
        );
      });

      fields.maintenanceHours = this.to_decimals(this.maintenanceHours, 0);

      fields.quote_date = moment().format("D/MM/YYYY");
      fields.quote_number = moment().format("YYYYMMDD") + this.item.id;

      fields.warranty_period = this.to_decimals(fields.warranty_period, 0);

      fields.non_project_hourly_rate = this.to_decimals(
        fields.non_project_hourly_rate,
        2
      );
      fields.project_hourly_rate = this.to_decimals(
        fields.project_hourly_rate,
        2
      );
      fields.project_weeks_low = this.to_decimals(
        this.totalExpectedCaseWeeks * 1.4,
        0
      );
      fields.project_weeks_high = this.to_decimals(
        this.totalExpectedCaseWeeks * 1.4 * 1.2,
        0
      );

      fields.priority_weeks_low = this.to_decimals(
        this.totalExpectedCaseWeeks,
        0
      );
      fields.priority_weeks_high = this.to_decimals(
        this.totalExpectedCaseWeeks * 1.4,
        0
      );

      fields.project_upfront = this.to_decimals(
        this.totalUpfrontCostProject,
        2
      );
      fields.priority_upfront = this.to_decimals(
        this.totalUpfrontCostFastTracked,
        2
      );
      fields.modules_upfront = this.to_decimals(this.totalUpfrontCostHourly, 2);

      fields.project_monthly = this.to_decimals(this.monthlyProject, 2);
      fields.priority_monthly = this.to_decimals(this.monthlyFastTracked, 2);
      fields.modules_monthly = this.to_decimals(this.monthly_hosting, 2);

      fields.monthly_hosting = this.to_decimals(this.monthly_hosting, 2);

      fields.project_maintenance = this.to_decimals(
        this.maintenanceFeeProject,
        2
      );
      fields.priority_maintenance = this.to_decimals(
        this.maintenanceFeeFastTracked,
        2
      );
      fields.modules_maintenance = this.to_decimals(
        fields.non_project_hourly_rate,
        2
      );

      fields.project_upfront_50 = this.to_decimals(
        this.totalUpfrontCostProject / 2,
        2
      ); //50% upfront
      fields.project_weekly_installments = this.to_decimals(
        this.totalUpfrontCostProject / 2 / fields.project_weeks_high,
        2
      );
      fields.project_installments_weeks = this.to_decimals(
        this.totalExpectedCaseWeeks * 1.4 * 1.2 - 1,
        0
      );
      fields.project_final_installment_amount =
        fields.project_weekly_installments;

      var request = {
        documentName: filename,
        fields: fields,
      };

      var root_url = process.env.VUE_APP_ROOT_API;
      this.axios
        .post(root_url + "/ocom_project/generate_doc/", request, {
          responseType: "arraybuffer",
        })
        .then(
          function (response, status, headers) {
            var a = document.createElement("a");
            var blob = new Blob([response.data], {
              type: response.headers["content-type"],
            });
            a.href = URL.createObjectURL(blob);
            a.download = vm.item.project_name + "-" + out_filename;
            a.click();
          },
          function (error) {
            console.log(error, "can not get data.");
          }
        );
    },
  },
  computed: {
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    },
    /* Calculations */
    totalbest_case() {
      return _.sumBy(this.item.modules, function (module) {
        return +module.best_case;
      });
    },

    totalmost_likely_case() {
      return _.sumBy(this.item.modules, function (module) {
        return +module.most_likely_case;
      });
    },

    totalworst_case() {
      return _.sumBy(this.item.modules, function (module) {
        return +module.worst_case;
      });
    },

    totalExpectedCase() {
      var vm = this;
      return _.sumBy(this.item.modules, function (module) {
        return vm.expected_case(module);
      });
    },

    totalExpectedCaseWeeks() {
      return Math.round(this.totalExpectedCase / 5);
    },

    maintenanceHours() {
      return Math.ceil(
        this.maintenanceFeeProject / parseFloat(this.item.project_hourly_rate),
        0
      );
    },

    maintenanceFeeProject() {
      return Math.max((this.totalUpfrontCostProject * 0.16) / 12, 75);
    },

    maintenanceFeeFastTracked() {
      return Math.max((this.totalUpfrontCostFastTracked * 0.16) / 12, 75);
    },

    totalUpfrontCostHourly() {
      return (
        this.totalExpectedCase *
        (parseFloat(this.item.non_project_hourly_rate) * 8)
      );
    },

    totalUpfrontCostProject() {
      var weeks = this.totalExpectedCaseWeeks;

      return this.item.project_weekly_rate * weeks;
    },

    totalUpfrontCostFastTracked() {
      return (
        this.totalUpfrontCostProject *
        (parseFloat(this.item.markup_for_fast_tracked) + 1)
      );
    },

    monthly_hosting() {
      if (this.item.include_hosting)
        return parseFloat(this.item.monthly_hosting);
      else return 0;
    },

    monthlyProject() {
      return this.monthly_hosting + this.maintenanceFeeProject;
    },

    monthlyFastTracked() {
      return this.monthly_hosting + this.maintenanceFeeFastTracked;
    },
  },
  watch: {},
  created() {},
};
</script>
